import { apiFetch } from "../../lib/utils";

const InternalCommentsEndPoint = "/InternalComments";

export type InternalComment = {
  id: number;
  text: string;
  created: string;    // DateTime från backend
  createdBy: string;
};

const getForReview = async (reviewId: number): Promise<InternalComment[]> => {
  try {
    const res = await apiFetch(`${InternalCommentsEndPoint}/api/review/${reviewId}`);
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to fetch internal comments for review:", e);
    return [];
  }
};

const createForReview = async (reviewId: number, text: string): Promise<InternalComment | null> => {
  try {
    const res = await apiFetch(
      `${InternalCommentsEndPoint}/api/review/${reviewId}`,
      "POST",
      JSON.stringify({ text }),
      { "Content-Type": "application/json" }
    );
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to create internal comment for review:", e);
    return null;
  }
};

const getForSending = async (sendingId: number): Promise<InternalComment[]> => {
  try {
    const res = await apiFetch(`${InternalCommentsEndPoint}/api/sending/${sendingId}`);
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to fetch internal comments for sending:", e);
    return [];
  }
};

const createForSending = async (sendingId: number, text: string): Promise<InternalComment | null> => {
  try {
    const res = await apiFetch(
      `${InternalCommentsEndPoint}/api/sending/${sendingId}`,
      "POST",
      JSON.stringify({ text }),
      { "Content-Type": "application/json" }
    );
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to create internal comment for sending:", e);
    return null;
  }
};
const update = async (commentId: number, text: string): Promise<InternalComment | null> => {
  try {
    const res = await apiFetch(
      `${InternalCommentsEndPoint}/api/${commentId}`,
      "PUT",
      JSON.stringify({ text }),
      { "Content-Type": "application/json" }
    );
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to update internal comment:", e);
    return null;
  }
};

const remove = async (commentId: number): Promise<boolean> => {
  try {
    const res = await apiFetch(`${InternalCommentsEndPoint}/api/${commentId}`, "DELETE");
    if (!res.ok) throw new Error(res.statusText);
    return true;
  } catch (e) {
    console.error("Failed to delete internal comment:", e);
    return false;
  }
};
const getForReviewPhoneReview = async (reviewPhoneReviewId: number): Promise<InternalComment[]> => {
  try {
    const res = await apiFetch(`${InternalCommentsEndPoint}/api/review-phone-review/${reviewPhoneReviewId}`);
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to fetch internal comments for review phone review:", e);
    return [];
  }
};

const createForReviewPhoneReview = async (
  reviewPhoneReviewId: number,
  text: string
): Promise<InternalComment | null> => {
  try {
    const res = await apiFetch(
      `${InternalCommentsEndPoint}/api/review-phone-review/${reviewPhoneReviewId}`,
      "POST",
      JSON.stringify({ text }),
      { "Content-Type": "application/json" }
    );
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    console.error("Failed to create internal comment for review phone review:", e);
    return null;
  }
};
export const InternalComments = {
  getForReview,
  createForReview,
  getForSending,
  createForSending,
  update,
  remove,
  getForReviewPhoneReview,
  createForReviewPhoneReview
};

